import { render } from "./AttendanceClock.vue?vue&type=template&id=5b88627c&scoped=true"
import script from "./AttendanceClock.vue?vue&type=script&lang=js"
export * from "./AttendanceClock.vue?vue&type=script&lang=js"

import "./AttendanceClock.vue?vue&type=style&index=0&id=5b88627c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b88627c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput});
